import React, { Component } from "react";
import { Paper, Typography, Button } from "@material-ui/core";
import { Modal } from "reactstrap";
import _ from "lodash";
import "./submittedReportsStyles.css";
export default class ChangeStatusModal extends Component {
    render() {
        const {
            modalInfo,
            setEditStatus,
            setReportStatus,
            setModalInfo,
            users,
            reportTitles,
            deleteReport
        } = this.props;
        let user = _.find(users, { uid: modalInfo.uid });
        let status =
            modalInfo.status === true
                ? "uneditable"
                : modalInfo.status === false
                ? "editable"
                : modalInfo.status;
        return (
            <Modal isOpen={modalInfo.state}>
                {modalInfo.state && (
                    <Paper>
                        <Typography style={{ margin: 15 }} variant="title">
                            {modalInfo.type === "delete" ? "Delete Report" : "Update Report Status"}
                        </Typography>
                        <Typography style={{ margin: 15 }} variant="body2">
                            {modalInfo.type === "delete" ? "Delete" : "Update"}{" "}
                            <b>{reportTitles[modalInfo.reportType]}</b> report submitted{" "}
                            <b>{modalInfo.timestamp}</b> by <b>{user.user_name}</b>{" "}
                            {modalInfo.type === "delete" ? "" : "to "}
                            <b>{status.toUpperCase()}</b>
                        </Typography>
                        {modalInfo.type === "delete" && (
                            <Typography style={{ margin: 15 }} variant="body2">
                                <b>This will delete this report data permanently! </b>
                            </Typography>
                        )}
                        <div style={{ float: "right", margin: 10 }}>
                            <Button
                                onClick={() => setModalInfo({ state: false })}
                                color="primary"
                                variant="contained"
                                style={{ marginRight: 5 }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    
                                    modalInfo.type === "edit"
                                        ? setEditStatus({
                                              uid: modalInfo.uid,
                                              timestamp: modalInfo.timestamp,
                                              reportType: modalInfo.reportType,
                                              status: modalInfo.status
                                          })
                                        : modalInfo.type === "delete"
                                        ? deleteReport({
                                              uid: modalInfo.uid,
                                              timestamp: modalInfo.timestamp,
                                              reportType: modalInfo.reportType,
                                              subjectName: modalInfo.subjectName,
                                              subjectChild: modalInfo.subjectChild
                                          })
                                        : setReportStatus({
                                              uid: modalInfo.uid,
                                              timestamp: modalInfo.timestamp,
                                              reportType: modalInfo.reportType,
                                              status: modalInfo.status
                                          });
                                    setModalInfo({ state: false });
                                }}
                            >
                                {modalInfo.type === "delete" ? "Delete" : "Update"}
                            </Button>
                        </div>
                    </Paper>
                )}
            </Modal>
        );
    }
}
